import { useTranslation } from "react-i18next";
import styled from "styled-components";

import StaticPageLayout from "../../components/StaticPageLayout";
import { termsContent, type TermsParagraph } from "./content";

const renderParagraph = (paragraph: TermsParagraph) => {
    if (typeof paragraph === "string") {
        return paragraph;
    }

    return (
        <>
            <strong>{paragraph.label}</strong>
            {paragraph.text}
        </>
    );
};

const TermsAndConditions = () => {
    const { i18n } = useTranslation();
    const locale = i18n.resolvedLanguage?.startsWith("en") ? "en" : "ua";
    const content = termsContent[locale];

    return (
        <StaticPageLayout>
            <RulesWrapper>
                <h1>{content.title}</h1>
                <p className="policy-description">{content.description}</p>
                {content.sections.map(section => (
                    <div className="policy-section" key={section.title}>
                        <h3>{section.title}</h3>
                        {section.paragraphs.map((paragraph, index) => (
                            <p key={`${section.title}-${index}`}>{renderParagraph(paragraph)}</p>
                        ))}
                    </div>
                ))}
            </RulesWrapper>
        </StaticPageLayout>
    );
};

export default TermsAndConditions;

const RulesWrapper = styled.div`
    padding: 35px 40px 45px;
    display: flex;
    max-width: 1020px;
    flex-direction: column;
    width: 100%;
    border-radius: 22px;
    background-color: #fff;
    border: 1px solid #e3ecff;
    box-shadow: 0 14px 45px rgba(16, 121, 255, 0.1);
    font-family: "Raleway";
    gap: 25px;
    margin: 0;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 6px;
        background: linear-gradient(90deg, #1677ff 0%, #5b8dff 50%, #9ad0ff 100%);
    }

    @media (max-width: 490px) {
        padding: 20px 16px 28px;
    }

    & > h1 {
        font-size: 50px;
        font-weight: 800;
        line-height: 65px;
        color: #212121;
        margin-top: 25px;

        @media (max-width: 821px) {
            padding: 0 20px;
            font-size: 40px;
            line-height: 52px;
        }

        @media (max-width: 490px) {
            padding: 0 20px;
            font-size: 36px;
            line-height: 46.8px;
        }
    }

    .policy-description {
        margin: 0;

        @media (max-width: 821px) {
            padding: 0 20px;
            font-size: 16px;
            line-height: 24px;
        }
    }

    strong {
        font-weight: bold;
    }

    p,
    a {
        font-weight: 400;
        font-size: 18px;
        line-height: 27px;
        color: #212121;
        font-family: "Roboto";
        margin: 0;

        @media (max-width: 821px) {
            font-size: 16px;
            line-height: 24px;
        }
    }

    .policy-section {
        display: flex;
        flex-direction: column;
        gap: 12px;

        h3 {
            font-size: 34px;
            font-weight: 700;
            line-height: 44.2px;
            font-family: "Raleway";
            color: #212121;
            margin: 0;

            @media (max-width: 821px) {
                font-size: 32px;
                line-height: 41.6px;
            }
        }

        @media (max-width: 821px) {
            padding: 0 20px;
        }
    }
`;
